import Pdf from "./pdf";

export default Pdf;
